/* eslint-disable no-unused-expressions */
import AuthenticationService from '@/services/AuthenticationService';
import { WeekdayGuard } from './RouterGuards';

setTimeout(() => import(/* webpackChunkName: "containers" */ '@/components/dishes/DishesContainer.vue'),
  import(/* webpackChunkName: "containers" */ '@/components/settings/SettingsContainer.vue'),
  import(/* webpackChunkName: "containers" */ '@/components/orders-list/OrdersListContainer.vue'),
  import(/* webpackChunkName: "containers" */ '@/components/orders-counts/OrdersCountsContainer.vue'),
  // import(/* webpackChunkName: "containers" */ '@/components/monthly-expenses/MonthlyExpensesContainer.vue');
  import(/* webpackChunkName: "containers" */ '@/components/orders-history/OrdersHistoryContainer.vue'),
  import(/* webpackChunkName: "containers" */ '@/components/dish-ratings/DishRatingsContainer.vue'),
  import(/* webpackChunkName: "containers" */ '@/components/external-provider/ExternalProviderContainer.vue'),
  import(/* webpackChunkName: "containers" */ '@/components/users-balances/UsersBalancesContainer.vue'),
  import(/* webpackChunkName: "containers" */ '@/components/error-page/ErrorContainer.vue'),
  10000);

const routes = [{
  path: '/error',
  name: 'errorPage',
  component: () => import('@/components/error-page/ErrorContainer.vue'),
  meta: { authenticated: false },
}, {
  path: '/forbidden',
  name: 'forbiddenPage',
  component: () => import('@/components/forbidden-page/ForbiddenContainer.vue'),
  meta: { authenticated: false },
}, {
  path: '/',
  redirect: 'dishes',
  component: () => import('@/components/main-component/MainComponent.vue'),
  meta: { authenticated: true },
  children: [
    {
      path: 'edit/:date?',
      component: () => import('@/components/editing/EditingContainer.vue'),
      meta: { admin: true },
    }, {
      path: 'dishes/:day/:provider?',
      component: () => import('@/components/dishes/DishesContainer.vue'),
      beforeEnter: WeekdayGuard,
      name: 'DishesContainer',
    }, {
      path: 'dishes',
      redirect: 'dishes/1',
    }, {
      path: 'settings',
      name: 'SettingsContainer',
      component: () => import('@/components/settings/SettingsContainer.vue'),
    }, {
      path: 'ordersList/:date?',
      name: 'ordersList',
      component: () => import('@/components/orders-list/OrdersListContainer.vue'),
    }, {
      path: 'ordersCounts',
      name: 'ordersCounts',
      component: () => import('@/components/orders-counts/OrdersCountsContainer.vue'),
    }, {
      // Deprecated: Users Expenses page
      //   path: 'monthlyExpenses/:month?',
      //   name: 'monthlyExpenses',
      //   component: () => import('@/components/monthly-expenses/MonthlyExpensesContainer.vue'),
      // }, {
      path: 'ordersHistory/:month?',
      name: 'ordersHistory',
      component: () => import('@/components/orders-history/OrdersHistoryContainer.vue'),
    }, {
      path: 'ratings/:date?',
      name: 'ratings',
      component: () => import('@/components/dish-ratings/DishRatingsContainer.vue'),
    }, {
      path: 'usersBalances',
      name: 'usersBalances',
      component: () => import('@/components/users-balances/UsersBalancesContainer.vue'),
    },
  ],
}, {
  path: '/logout',
  meta: { authenticated: true },
  beforeEnter: () => {
    AuthenticationService.logout();
  },
}, {
  path: '/newProvider/:guid',
  component: () => import('@/components/external-provider/ExternalProviderContainer.vue'),
}, {
  path: '*', redirect: '/',
},
];

export default {
  routes,
};
